document.addEventListener("DOMContentLoaded", function() {
  document.addEventListener("click", function(e) {
    var nav = document.getElementById("mainNav");
    var toggle = document.querySelector(".nav-toggle");
    if (nav && toggle && nav.classList.contains("open") && !nav.contains(e.target) && !toggle.contains(e.target)) {
      nav.classList.remove("open");
    }
  });
});
